import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emptyDash' })
export class EmptyDashPipe implements PipeTransform {
  transform(value: any): string {
    return value === null || value === undefined || value === '' ? '--' : value;
  }
}